module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/result/doctor01-ed89784e2f64e20266344ec501d26895.png";